import { Box } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import SvgToIcon from "../../icons/SvgToIcon";
import LoadingIcon from "../LoadingIcon";

export default function IconButton({
  onClick,
  IconSVG,
  size = "S",
  buttonStyle = "outlined",
  color = "inherit",
  disabled = false,
  loading = false,
}) {
  const enabled = !disabled && !loading;

  const colors = useColors();
  const sizeMap = {
    XS: {
      containerSize: "24px",
      iconSize: "16px",
      border: "1px",
      borderRadius: "6px",
      loadingSize: "12px",
    },
    S: {
      containerSize: "32px",
      iconSize: "18px",
      border: "1px",
      borderRadius: "8px",
      loadingSize: "14px",
    },
    M: {
      containerSize: "36px",
      iconSize: "24px",
      border: "1px",
      borderRadius: "8px",
      loadingSize: "16px",
    },
    L: {
      containerSize: "48px",
      iconSize: "28px",
      border: "1px",
      borderRadius: "8px",
      loadingSize: "20px",
    },
  };

  const colorMap = {
    outlined: {
      inherit: {
        enabled: {
          bg: colors.icon_button_inherit_enabled_bg,
          stroke: colors.icon_button_inherit_enabled_stroke,
          icon: colors.icon_button_inherit_icon,
        },
        hovered: {
          bg: colors.icon_button_inherit_hovered_bg,
          stroke: colors.icon_button_inherit_icon,
          icon: colors.icon_button_inherit_icon,
        },
        disabled: {
          bg: colors.icon_button_inherit_disabled_bg,
          stroke: colors.icon_button_inherit_disabled_stroke,
          icon: colors.icon_button_inherit_disabled_icon,
        },
      },
    },
    standard: {
      inherit: {
        enabled: {
          bg: "none",
          icon: colors.icon_button_inherit_icon,
        },
        hovered: {
          bg: "none",
          icon: colors.icon_button_inherit_icon,
        },
        disabled: {
          bg: "none",
          icon: colors.icon_button_circular_disabled_icon,
        },
      },
    },
  };

  const currentColors = colorMap[buttonStyle][color];

  return (
    <Box
      onClick={enabled ? onClick : null}
      width={sizeMap[size].containerSize}
      height={sizeMap[size].containerSize}
      border={
        buttonStyle === "outlined"
          ? `${sizeMap[size].border} solid ${
              enabled
                ? currentColors.enabled.stroke
                : currentColors.disabled.stroke
            }`
          : "none"
      }
      borderRadius={
        buttonStyle === "circular" ? "50%" : sizeMap[size].borderRadius
      }
      sx={{
        backgroundColor: enabled
          ? currentColors.enabled.bg
          : currentColors.disabled.bg,
        cursor: enabled ? "pointer" : "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: enabled
            ? currentColors.hovered.bg
            : currentColors.disabled.bg,
          borderColor: enabled
            ? currentColors.hovered.stroke
            : currentColors.disabled.stroke,
        },
      }}
    >
      {loading ? (
        <LoadingIcon size={sizeMap[size].loadingSize} />
      ) : (
        <SvgToIcon
          IconLogo={IconSVG}
          width={sizeMap[size].iconSize}
          style={{
            color: enabled
              ? currentColors.enabled.icon
              : currentColors.disabled.icon,
          }}
        />
      )}
    </Box>
  );
}
